export default __webpack_public_path__ + "static/media/KZ.M.09.2201 black.8bc701ca.svg";